import React from "react";
import QuestionReportModalState, { QuestionReportModalProps } from "./QuestionReportModal.models";
import './QuestionReportModal.scss';
import { Modal } from "react-bootstrap";
import QuestionReportService from "../../../services/exam/QuestionReportService";

export default class QuestionReportModal extends React.PureComponent<QuestionReportModalProps, QuestionReportModalState>{

    questionReport: QuestionReportService;
    constructor(props: any) {
        super(props);
        this.questionReport = new QuestionReportService();
        this.state = { hasReport: false, questionReportEditionDTO: {} };
    }

    componentDidMount = () => {
        this.setParams();
    }

    componentDidUpdate = (prevProps: any) => {
        if (prevProps.questionStoreId !== this.props.questionStoreId || prevProps.questionCategoryId !== this.props.questionCategoryId) {
            this.setParams();
        }
    }

    setParams = () => {
        let questionCategoryId = this.props.questionCategoryId !== null && this.props.questionCategoryId !== undefined ? Number(this.props.questionCategoryId) : null;
        let questionStoreId = this.props.questionStoreId !== null && this.props.questionStoreId !== undefined ? Number(this.props.questionStoreId) : null;

        this.setState({ questionReportEditionDTO: { questionCategoryId: questionCategoryId, questionStoreId: questionStoreId } });
        this.forceUpdate();
    }

    submitHandler = () => {
        let self = this;
        let state = this.state;

        if (state.questionReportEditionDTO.description === undefined || state.questionReportEditionDTO.description === null || state.questionReportEditionDTO.description === '') {
            //#TODO adding notify
            return this.setState({ errorMessage: 'لطفا علت خرابی سوال را وارد کنید.' })
        }

        this.questionReport.hasQuestionReport({ questionCategoryId: state.questionReportEditionDTO.questionCategoryId, questionStoreId: state.questionReportEditionDTO.questionStoreId }).then(function (response) {
            if (response.hasQuestion) {
                self.saveChanges();
            }
            else {
                self.save();
            }
        })
    }

    save = () => {
        let self = this;
        let state = this.state;
        this.questionReport.create(state.questionReportEditionDTO).then(function (response) {
            if (response.status === 200 || response.status === 204) {
                self.props.onClose();
                self.clear();
            }
        })

        //#TODO
        // _toastService.ShowSuccess("گزارش شما با موفقیت ثبت شد", "گزارش خرابی سوال");
    }

    saveChanges = () => {
        let self = this;
        let state = this.state;

        this.questionReport.update(state.questionReportEditionDTO).then(function (response) {
            if (response.status === 200 || response.status === 204) {
                self.props.onClose();
                self.clear();
            }
        })

        //#TODO
        // _toastService.ShowSuccess("گزارش شما با موفقیت بروز رسانی شد", "گزارش خرابی سوال");
    }

    clear = () => {
        this.setState((prevState) => { return { hasReport: false, questionReportEditionDTO: { ...prevState.questionReportEditionDTO, description: '' } } });
    }

    render(): React.ReactNode {
        let { showModal, onClose } = this.props;
        let { questionReportEditionDTO } = this.state;

        return (<>

            <Modal show={showModal} onHide={onClose} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>گزارش خرابی سوال</label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-right">
                        <label>علت خرابی سوال</label>
                        <textarea className="form-control" value={questionReportEditionDTO.description} onChange={e => this.setState((prevState) => {
                            return { questionReportEditionDTO: { ...prevState.questionReportEditionDTO, description: e.target.value }, errorMessage: undefined }
                        })}></textarea>
                        {
                            this.state.errorMessage && <label className="text-danger">{this.state.errorMessage}</label>
                        }
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn-success tk-float-right" onClick={this.submitHandler}>ثبت</button>
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={onClose}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}